import reducer from "../core/reducer";

import {
  ACTIVATE_CITY_TAX_PAYMENT,
  ACTIVATE_CITY_TAX_PAYMENT_FAIL,
  ACTIVATE_CITY_TAX_PAYMENT_SUCCESS,
  CONFIRM_CITY_TAX_PAYMENT,
  CONFIRM_CITY_TAX_PAYMENT_FAIL,
  CONFIRM_CITY_TAX_PAYMENT_SUCCESS,
  ACTIVATE_RESERVATIONS_PAYMENT,
  ACTIVATE_RESERVATIONS_PAYMENT_FAIL,
  ACTIVATE_RESERVATIONS_PAYMENT_SUCCESS,
  CONFIRM_RESERVATIONS_PAYMENT,
  CONFIRM_RESERVATIONS_PAYMENT_FAIL,
  CONFIRM_RESERVATIONS_PAYMENT_SUCCESS,
  CREATE_SETUP_INTENT,
  CREATE_SETUP_INTENT_FAIL,
  CREATE_SETUP_INTENT_SUCCESS,
  CREATE_PAYMENT_INTENT,
  CREATE_PAYMENT_INTENT_FAIL,
  CREATE_PAYMENT_INTENT_SUCCESS,
  CREATE_CITY_TAX_PAYMENT_INTENT,
  CREATE_CITY_TAX_PAYMENT_INTENT_FAIL,
  CREATE_CITY_TAX_PAYMENT_INTENT_SUCCESS,
  GET_CONNECT_ACCOUNT_ID,
  GET_CONNECT_ACCOUNT_ID_FAIL,
  GET_CONNECT_ACCOUNT_ID_SUCCESS,
} from "./constants";

export default reducer({
  actions: [
    {
      method: "post",
      name: "activateCityTaxPaymentRequest",
      action: ACTIVATE_CITY_TAX_PAYMENT,
      endPoint: "be/1.0/payments/activate-city-tax-payment",
      mutations: {
        fail: ACTIVATE_CITY_TAX_PAYMENT_FAIL,
        success: ACTIVATE_CITY_TAX_PAYMENT_SUCCESS,
      },
    },
    {
      method: "post",
      name: "confirmCityTaxPaymentRequest",
      action: CONFIRM_CITY_TAX_PAYMENT,
      endPoint: "be/1.0/payments/confirm-city-tax-payment",
      mutations: {
        fail: CONFIRM_CITY_TAX_PAYMENT_FAIL,
        success: CONFIRM_CITY_TAX_PAYMENT_SUCCESS,
      },
    },
    {
      method: "post",
      name: "activateReservationsPaymentRequest",
      action: ACTIVATE_RESERVATIONS_PAYMENT,
      endPoint: "be/1.0/payments/activate-reservations-payment",
      mutations: {
        fail: ACTIVATE_RESERVATIONS_PAYMENT_FAIL,
        success: ACTIVATE_RESERVATIONS_PAYMENT_SUCCESS,
      },
    },
    {
      method: "post",
      name: "confirmReservationsPaymentRequest",
      action: CONFIRM_RESERVATIONS_PAYMENT,
      endPoint: "be/1.0/payments/confirm-reservations-payment",
      mutations: {
        fail: CONFIRM_RESERVATIONS_PAYMENT_FAIL,
        success: CONFIRM_RESERVATIONS_PAYMENT_SUCCESS,
      },
    },
    {
      method: "post",
      name: "createSetupIntent",
      action: CREATE_SETUP_INTENT,
      endPoint: "api/pay-public/v1/payments/stripe/be/setup-intent",
      mutations: {
        fail: CREATE_SETUP_INTENT_FAIL,
        success: CREATE_SETUP_INTENT_SUCCESS,
      },
    },
    {
      method: "post",
      name: "createPaymentIntent",
      action: CREATE_PAYMENT_INTENT,
      endPoint: "api/pay-public/v1/payments/stripe/be/payment-intent",
      mutations: {
        fail: CREATE_PAYMENT_INTENT_FAIL,
        success: CREATE_PAYMENT_INTENT_SUCCESS,
      },
    },
    {
      method: "post",
      name: "createCityTaxPaymentIntent",
      action: CREATE_CITY_TAX_PAYMENT_INTENT,
      endPoint: "api/pay-public/v1/payments/stripe/sc/payment-intent",
      mutations: {
        fail: CREATE_CITY_TAX_PAYMENT_INTENT_FAIL,
        success: CREATE_CITY_TAX_PAYMENT_INTENT_SUCCESS,
      },
    },
    {
      method: "get",
      name: "getConnectAccountId",
      action: GET_CONNECT_ACCOUNT_ID,
      endPoint:
        "api/pay-public/v1/payment-configurations/type/{ownerType}/id/{ownerId}/accountId",
      mutations: {
        fail: GET_CONNECT_ACCOUNT_ID_FAIL,
        success: GET_CONNECT_ACCOUNT_ID_SUCCESS,
      },
    },
  ],
});
